import React, { useState } from 'react';
import { Building2, Map, FileText, Scale, AlertCircle, TrendingDown, Minus, TrendingUp } from 'lucide-react';
import { LegalFilingsModal } from './LegalFilingsModal';
export function InitechDetailsTab() {
  const [legalTab, setLegalTab] = useState('ALL');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFilingIndex, setSelectedFilingIndex] = useState(0);
  const handleOpenModal = (index: number) => {
    setSelectedFilingIndex(index);
    setIsModalOpen(true);
  };
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1922" data-mp="3bt1oc291xdk7">
      {/* Company Details - 3 Column Layout */}
      <div className="grid grid-cols-3 gap-6" data-id="element-1923" data-mp="2xuttq0zhmoc7">
        {/* Registration */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-1924" data-mp="31ucbwozxclbc">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-1925" data-mp="w2fa8xhapbto">Registration</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs" data-id="element-1926" data-mp="101o6qa3pznsx">
            <div data-id="element-1927" data-mp="1z6ri8wk4xprl">
              <p className="font-semibold text-gray-900" data-id="element-1928" data-mp="1z69d1afhw17j">SOS State</p>
              <p className="text-gray-600" data-id="element-1929" data-mp="1u7y3l0t43spu">TX</p>
            </div>
            <div data-id="element-1930" data-mp="1u7etg69pe8md">
              <p className="font-semibold text-gray-900" data-id="element-1931" data-mp="1u5vcedg83tjj">Founded Date</p>
              <p className="text-gray-600" data-id="element-1932" data-mp="28wb1w4fo9nni">1993</p>
            </div>
            <div data-id="element-1933" data-mp="23xhlo4903ijn">
              <p className="font-semibold text-gray-900" data-id="element-1934" data-mp="23z2i5zevlbk5">SOS Number</p>
              <p className="text-gray-600" data-id="element-1935" data-mp="1g7ncbwnw4c45">1234567</p>
            </div>
            <div data-id="element-1936" data-mp="1ga004qgbxgp4">
              <p className="font-semibold text-gray-900" data-id="element-1937" data-mp="1b9c1pjprtxkv">Type</p>
              <p className="text-gray-600" data-id="element-1938" data-mp="1bb6o72goxxr2">C-Corporation</p>
            </div>
            <div data-id="element-1939" data-mp="1q7xpjh9xdjjb">
              <p className="font-semibold text-gray-900" data-id="element-1940" data-mp="1q49ugdou0p2h">TIN Number</p>
              <p className="text-gray-600" data-id="element-1941" data-mp="1l6gqlrb0475d">74-2847291</p>
            </div>
            <div data-id="element-1942" data-mp="31l03e4kn3uzs">
              <p className="font-semibold text-gray-900" data-id="element-1943" data-mp="31kgoyxu77oqi">DBAs</p>
              <p className="text-gray-600" data-id="element-1944" data-mp="2wmov3y9ztsjo">INITECH</p>
            </div>
            <div data-id="element-1945" data-mp="2woj54hjq808z">
              <p className="font-semibold text-gray-900" data-id="element-1946" data-mp="33pn08u14b1gb">Domestic / Foreign</p>
              <p className="text-gray-600" data-id="element-1947" data-mp="33rpnx7essihv">Domestic</p>
            </div>
            <div data-id="element-1948" data-mp="38nev9wx273oq">
              <p className="font-semibold text-gray-900" data-id="element-1949" data-mp="38mvc6cvoa994">Entity Type</p>
              <p className="text-gray-600" data-id="element-1950" data-mp="3dp45598jpbb8">Private Company</p>
            </div>
          </div>
        </div>

        {/* Information */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-1951" data-mp="3ikt5hese2w8l">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-1952" data-mp="2l0ykemhhrmbe">Information</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs mb-3" data-id="element-1953" data-mp="2pz01x2z9rdkr">
            <div data-id="element-1954" data-mp="2uwrwk4ratdsn">
              <p className="font-semibold text-gray-900" data-id="element-1955" data-mp="2uw9xl0d94lh1">SIC</p>
              <p className="text-gray-600" data-id="element-1956" data-mp="2znrqr2919hrg">7372 - SOFTWARE SERVICES</p>
            </div>
            <div data-id="element-1957" data-mp="228nml71p2ek5">
              <p className="font-semibold text-gray-900" data-id="element-1958" data-mp="2295q8oqorv23">Ticker</p>
              <p className="text-gray-600" data-id="element-1959" data-mp="226tb0jcbbysq">--</p>
            </div>
            <div data-id="element-1960" data-mp="276flil0rb0xu">
              <p className="font-semibold text-gray-900" data-id="element-1961" data-mp="275w2f0zde6i8">NAICS</p>
              <p className="text-gray-600" data-id="element-1962" data-mp="obkyut5we0ii">
                541511 - CUSTOM COMPUTER PROGRAMMING
              </p>
            </div>
            <div data-id="element-1963" data-mp="kbsoqc0uvmb1">
              <p className="font-semibold text-gray-900" data-id="element-1964" data-mp="k96bpwv74elf">Approximate Revenue</p>
              <p className="text-gray-600" data-id="element-1965" data-mp="fa3bqqu2oykb">~$12 Million</p>
            </div>
          </div>
          <div className="text-xs" data-id="element-1966" data-mp="acl8nh2qldk8">
            <p className="font-semibold text-gray-900 mb-0.5" data-id="element-1967" data-mp="5dqitv6cqoqm">Description</p>
            <p className="text-gray-600 line-clamp-3" data-id="element-1968" data-mp="5fuuizahss1g">
              Initech provides enterprise software solutions and IT consulting
              services. The company has faced significant challenges in recent
              years due to market competition and operational inefficiencies.
            </p>
            <button className="text-indigo-600 hover:text-indigo-700 font-medium mt-1" data-id="element-1969" data-mp="3npwqb04ufzyq">
              More
            </button>
          </div>
        </div>

        {/* Location */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex flex-col" data-id="element-1970" data-mp="3dubqn8n8zbs5">
          <div className="flex justify-between items-start mb-2" data-id="element-1971" data-mp="1hr70rxfsd3k8">
            <h3 className="text-sm font-bold text-gray-900" data-id="element-1972" data-mp="1mogq7d36df82">Location</h3>
            <Map className="w-4 h-4 text-indigo-600" data-id="element-1973" data-mp="180vptqxopu3u" />
          </div>
          <div className="text-xs text-gray-600 mb-2" data-id="element-1974" data-mp="17yrlj7vvit31">
            <p data-id="element-1975" data-mp="1cynfsferr65e">4120 FREIDRICH LANE</p>
            <p data-id="element-1976" data-mp="1cxm180yjo1ix">AUSTIN, TX 78744, US</p>
          </div>
          <div className="flex-1 bg-gray-100 rounded-lg border border-gray-200 overflow-hidden max-h-[150px]" data-id="element-1977" data-mp="yyw5aongo7w5">
            <img src="https://cdn.magicpatterns.com/uploads/qtwTgDCBXd62qhtqnM4cnL/image.png" alt="Initech Office Building - Austin, TX" className="w-full h-full object-cover" data-id="element-1978" data-mp="13zs62tcindxc" />
          </div>
        </div>
      </div>

      {/* Legal Filings */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1979" data-mp="2jh2dps8jpviw">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50/50" data-id="element-1980" data-mp="2odkgwno89lt4">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1981" data-mp="csa8t29i1vel">Legal Filings (3)</h3>
          <div className="flex bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden text-sm font-medium" data-id="element-1982" data-mp="7t72lehs9j51">
            {['ALL', 'LAWSUITS', 'LIENS', 'UCC', 'BANKRUPTCY'].map(tab => <button key={tab} onClick={() => setLegalTab(tab)} className={`px-4 py-2 border-r border-gray-200 last:border-r-0 flex items-center gap-2 transition-colors ${legalTab === tab ? 'bg-gray-100 text-gray-900' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`} data-id="element-1983" data-mp="hpk4v0re95be">
                {tab === 'LAWSUITS' && <Scale className="w-4 h-4" data-id="element-1984" data-mp="10h34cxm7m18o" />}
                {tab === 'LIENS' && <FileText className="w-4 h-4" data-id="element-1985" data-mp="10hw3pdiu9ogs" />}
                {tab === 'UCC' && <Building2 className="w-4 h-4" data-id="element-1986" data-mp="378ltihs4atcs" />}
                {tab === 'BANKRUPTCY' && <AlertCircle className="w-4 h-4" data-id="element-1987" data-mp="328ppiijf71x8" />}
                {tab}
              </button>)}
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-1988" data-mp="166mkg3is0uk8">
          {(legalTab === 'ALL' || legalTab === 'LIENS') && <button onClick={() => handleOpenModal(0)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1989" data-mp="1b4o6mxbi19zx">
              <div className="flex items-center gap-4" data-id="element-1990" data-mp="1k6nm3l6v860r">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-1991" data-mp="1p4p5664ak5c8">
                  <FileText className="w-5 h-5 text-gray-500" data-id="element-1992" data-mp="1u2gvivpafjeb" />
                </div>
                <div className="text-left" data-id="element-1993" data-mp="1ytgt8368e5hv">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-1994" data-mp="1yuigr74fokgh">
                    <h4 className="font-bold text-gray-900" data-id="element-1995" data-mp="22vtykqh2g1e4">
                      TRAVIS COUNTY RECORDER
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-red-500" title="Active" data-id="element-1996" data-mp="27w84o2z3x19i"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1997" data-mp="2myq21cud69mo">
                    STATE TAX LIEN • ACTIVE
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-1998" data-mp="2cz90n7m5ahwi">
                <p className="font-medium text-gray-900" data-id="element-1999" data-mp="2d0aefjujpihx">11/15/2025</p>
                <p className="text-sm text-gray-500" data-id="element-2000" data-mp="28yfas8p56t0z">$45,800</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'UCC') && <button onClick={() => handleOpenModal(1)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-2001" data-mp="30p3arhf2xsd2">
              <div className="flex items-center gap-4" data-id="element-2002" data-mp="2vw0hzbi4mmxx">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-2003" data-mp="2rw01llbgw1o8">
                  <Building2 className="w-5 h-5 text-gray-500" data-id="element-2004" data-mp="3og8qlwl0sknd" />
                </div>
                <div className="text-left" data-id="element-2005" data-mp="3jn5vhk0lh352">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-2006" data-mp="3jm4lzjz88opg">
                    <h4 className="font-bold text-gray-900" data-id="element-2007" data-mp="750rkrx6mk1c">
                      AUSTIN COMMUNITY BANK
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-red-500" title="Active" data-id="element-2008" data-mp="bz503fm3j04j"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-2009" data-mp="27sdp3j2h25w">
                    UCC FILING • BLANKET LIEN ON ALL ASSETS
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-2010" data-mp="uuv93msg4wrx">
                <p className="font-medium text-gray-900" data-id="element-2011" data-mp="fyxfoc9wq6je">10/5/2025</p>
                <p className="text-sm text-gray-500" data-id="element-2012" data-mp="fynnqj5axpb2">$150,000</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'LAWSUITS') && <button onClick={() => handleOpenModal(2)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-2013" data-mp="30od3cydtxf4t">
              <div className="flex items-center gap-4" data-id="element-2014" data-mp="1npjlgff4e62y">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-2015" data-mp="1iri01nu81uob">
                  <Scale className="w-5 h-5 text-gray-500" data-id="element-2016" data-mp="1wr0zls8yvxp0" />
                </div>
                <div className="text-left" data-id="element-2017" data-mp="1sppg84gos8p9">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-2018" data-mp="1sqqsuddcp393">
                    <h4 className="font-bold text-gray-900" data-id="element-2019" data-mp="14zv1tigpyc2w">
                      EMPLOYEE CLASS ACTION LAWSUIT
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-red-500" title="Active" data-id="element-2020" data-mp="102bcnnihgew6"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-2021" data-mp="191gassq4u67t">
                    CIVIL LAWSUIT • WRONGFUL TERMINATION • ACTIVE
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-2022" data-mp="hasfhxb53v22">
                <p className="font-medium text-gray-900" data-id="element-2023" data-mp="ha0qx6fymxla">9/22/2025</p>
                <p className="text-sm text-gray-500" data-id="element-2024" data-mp="3g63xaxvrc3gd">$2.5M claimed</p>
              </div>
            </button>}
        </div>
      </div>

      {/* News */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2025" data-mp="3755p03ead9rz">
        <div className="p-5 border-b border-gray-200" data-id="element-2026" data-mp="3770dfrornk0t">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-2027" data-mp="325axbxmosg5v">News</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-2028" data-mp="2x79ffg0zymvz">
          <table className="w-full text-sm text-left" data-id="element-2029" data-mp="2x8astr5hjlgv">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-2030" data-mp="2sg14gfk0qtgp">
              <tr data-id="element-2031" data-mp="2ngwuvnt6mtpu">
                <th className="px-5 py-3 font-medium" data-id="element-2032" data-mp="2ngeq22sgf76b">Date</th>
                <th className="px-5 py-3 font-medium" data-id="element-2033" data-mp="2jfl61ki4ucip">Title</th>
                <th className="px-5 py-3 font-medium" data-id="element-2034" data-mp="2jh5woz1btbba">Sentiment</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2035" data-mp="2efqcf96z38ty">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2036" data-mp="29h5bf7jwcl4g">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-2037" data-mp="ozczt7qikvpz">
                  Feb 15, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-2038" data-mp="txxxazedt1aq">
                  Initech Reports 35% Revenue Decline, Announces Additional
                  Layoffs
                </td>
                <td className="px-5 py-4" data-id="element-2039" data-mp="12zns8f7h2id9">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200" data-id="element-2040" data-mp="12ym53cd6m5f6">
                    <TrendingDown className="w-3.5 h-3.5" data-id="element-2041" data-mp="b7g7b2kxojt2" />
                    Negative
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2042" data-mp="f7goguzf393t">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-2043" data-mp="k1bdmdxskgaa">
                  Nov 22, 2025
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-2044" data-mp="3jnj8qqlgdc8y">
                  Initech Suffers Major Cybersecurity Breach, Customer Data
                  Compromised
                </td>
                <td className="px-5 py-4" data-id="element-2045" data-mp="ut1vm8orft44">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200" data-id="element-2046" data-mp="pw347xwhe09m">
                    <TrendingDown className="w-3.5 h-3.5" data-id="element-2047" data-mp="14msf0z615dcy" />
                    Negative
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2048" data-mp="bv8rj32ehd55">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-2049" data-mp="6wxgwq4a6ylv">
                  Sep 22, 2025
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-2050" data-mp="kx8ba34suvbs">
                  Former Employees File Class Action Lawsuit Against Initech
                </td>
                <td className="px-5 py-4" data-id="element-2051" data-mp="gxhlo2r0el8u">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200" data-id="element-2052" data-mp="1wau90coq658x">
                    <TrendingDown className="w-3.5 h-3.5" data-id="element-2053" data-mp="1ztt2a0fq5x5e" />
                    Negative
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2054" data-mp="24tnqtxc12ana">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-2055" data-mp="1pw53mzf005hy">
                  Apr 12, 2025
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-2056" data-mp="1uvhq3j1yjak0">
                  Initech Announces Partnership with Enterprise Cloud Provider
                </td>
                <td className="px-5 py-4" data-id="element-2057" data-mp="2njx4q4h6fqut">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-50 text-gray-700 border border-gray-200" data-id="element-2058" data-mp="2niug637bu0i2">
                    <Minus className="w-3.5 h-3.5" data-id="element-2059" data-mp="2dssq55vey80i" />
                    Neutral
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Affiliated Companies */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2060" data-mp="36b6dgbj4iblc">
        <div className="p-5 border-b border-gray-200" data-id="element-2061" data-mp="1in4tu0uikudq">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-2062" data-mp="1dlxl9zkjrr60">
            Affiliated Companies
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-2063" data-mp="18of980b8gvts">
          <table className="w-full text-sm text-left" data-id="element-2064" data-mp="18pgpqkb0qaiw">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-2065" data-mp="13pcg9e8j2g26">
              <tr data-id="element-2066" data-mp="21cb552szajpi">
                <th className="px-5 py-3 font-medium" data-id="element-2067" data-mp="21aqald6nz0rn">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-2068" data-mp="1wd8c6gq9w3xw">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-2069" data-mp="1wdqcppjyx4bm">Country</th>
                <th className="px-5 py-3 font-medium w-12" data-id="element-2070" data-mp="1rl6swauotcyd"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2071" data-mp="1mm3tb5xh7yxs">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2072" data-mp="2k2j3z8pnanzw">
                <td className="px-5 py-3 text-gray-500" data-id="element-2073" data-mp="2k3u8xbutu1sl">--</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-2074" data-mp="2fbko2a8kjrx6">--</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-2075" data-mp="2nkgleprt1pdl">--</td>
                <td className="px-5 py-3" data-id="element-2076" data-mp="2nm1gcgi17abz"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Branch Offices */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2077" data-mp="2wkltl24torst">
        <div className="p-5 border-b border-gray-200" data-id="element-2078" data-mp="31jyaz7cxd6o0">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-2079" data-mp="31ljazci0dht9">Branch Offices</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-2080" data-mp="36it4p4cfkfmw">
          <table className="w-full text-sm text-left" data-id="element-2081" data-mp="3ako6sb26qx1q">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-2082" data-mp="3ajd3sdgkdtbo">
              <tr data-id="element-2083" data-mp="3fcxs1dscv8xo">
                <th className="px-5 py-3 font-medium" data-id="element-2084" data-mp="3fcel0s48u4yf">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-2085" data-mp="3kazbhztp1a9o">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-2086" data-mp="3p9sprugt15aw">Address</th>
                <th className="px-5 py-3 font-medium" data-id="element-2087" data-mp="3pbdlvoirowav">Country</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2088" data-mp="3u95buczuq8cf">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-2089" data-mp="34jyk37oynzfc">
                <td className="px-5 py-3 text-gray-900" data-id="element-2090" data-mp="34if65nqs20gq">INITECH HQ</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-2091" data-mp="2znhwqfpl5p3b">Headquarters</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-2092" data-mp="3ebmg7lwgq4n5">
                  4120 Freidrich Lane, Austin, TX 78744
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-2093" data-mp="39ijhz0gqq70m">US</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && <LegalFilingsModal onClose={() => setIsModalOpen(false)} initialIndex={selectedFilingIndex} company="initech" data-id="element-2094" data-mp="3ib4sxue4r9ew" />}
    </div>;
}